import React, { useState } from 'react';
import { Modal, Image } from 'antd';
import ImageGalleryMobile from './ImageGalleryMobile';

const ImageGallery = ({ images_parkingAt, facilityLot }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const getImageClasses = (index, length) => {
    if (length >= 4) {
      if (index < 2) return 'w-full h-[320px]'; // Larger images
      return 'w-[380px] h-[155px]'; // Smaller images
    } else if (length === 3) {
      return index === 0 ? 'w-full h-[320px]' : 'w-[380px] h-[320px]'; // Different for 3 images
    } else if (length === 2) {
      return 'w-[640px] h-[320px]'; // Same size for 2 images
    }
    return 'w-full h-full'; // Full size for 1 image
  };

  const getGridClasses = (length) => {
    switch (length) {
      case 5:
        return 'grid-cols-[4fr_3fr_3fr] grid-rows-[repeat(2,_1fr)] gap-x-2';
      case 4:
        return 'grid-cols-[4fr_3fr_3fr] grid-rows-[repeat(2,_1fr)] gap-x-2';
      case 3:
        return 'grid-cols-[4fr_3fr_3fr] grid-rows-auto gap-x-2';
      case 2:
        return 'grid-cols-[4fr_4fr] grid-rows-auto gap-x-2';
      default:
        return 'grid-cols-1 gap-x-2';
    }
  };

  const getGridItemClasses = (index, length) => {
    if (length === 5) {
      switch (index) {
        case 0:
          return 'row-span-2 col-span-1'; // First image spans 2 rows
        case 1:
        case 2:
          return 'row-span-1 col-span-1'; // Second and third images
        default:
          return '';
      }
    }
    if (length === 4) {
      switch (index) {
        case 0:
          return 'row-span-2 col-span-1'; // First image spans 2 rows
        case 1:
          return 'row-span-2 col-span-1'; // Second image spans 2 rows
        case 2:
        case 3:
          return 'row-span-1 col-span-1'; // Third and fourth images
        default:
          return '';
      }
    }
    if (length === 3 || length === 2) {
      return 'row-span-1 col-span-1'; // All images equal
    }
    return ''; // Fallback for 1 image
  };

  return (
    <>
      <div className={`grid w-full ${getGridClasses(images_parkingAt.length)}`}>
        {images_parkingAt.map((image, index) => (
          <div
            key={image.id}
            className={`relative cursor-pointer ${getGridItemClasses(
              index,
              images_parkingAt.length
            )}`}
            onClick={showModal}
          >
            <Image
              src={image.image_url}
              alt={image.image_description}
              className={`rounded-xl ${getImageClasses(
                index,
                images_parkingAt.length
              )}`}
              preview={false}
            />
          </div>
        ))}
      </div>

      {isModalVisible && (
        <Modal
          visible={isModalVisible}
          className="w-[930px]"
          footer={false}
          onCancel={handleCancel}
        >
          <div className="w-full relative">
            <h2 className="text-lg font-medium text-gray-800 mb-4 text-center">
              {facilityLot}
            </h2>
            <ImageGalleryMobile images_parkingAt={images_parkingAt} />
          </div>
        </Modal>
      )}
    </>
  );
};

export default ImageGallery;
